import React, { useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  Button,
  Icon
} from "../../components/Component";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";

import * as moment from "moment";
import { NumericFormat } from "react-number-format";
import DatePicker from "../../components/range-date-picker/RangeDatePicker";
import Table from "../../components/react-table/Table";
import { DELETE, GET } from "../../helper/api";

import { useHistory, useLocation } from 'react-router-dom';
import ReactToPrint from 'react-to-print';
import { getToken } from "../../helper/auth";


const MortgageContractTransactionHistory = () => {
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const printRef = useRef();

  const [data, setData] = useState([]);

  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [summary, setSummary] = useState({});
  const [type, setType] = useState('IN')
  const [filter, setFilter] = useState({
  });
  const [editId, setEditedId] = useState();
  const [deleteId, setDeleteId] = useState();
  const [view, setView] = useState({
    edit: false,
    add: false,
    isDelete: false,
  });

  const [rangeDate, setRangeDate] = useState({
    start: searchParams.get("start")
      ? moment(searchParams.get("start")).startOf("days").toDate()
      : moment().startOf("months").toDate(),
    end: searchParams.get("end")
      ? moment(searchParams.get("end")).endOf("days").toDate()
      : moment().endOf("months").toDate(),
  });
  const [updatedAt, setUpdatedAt] = useState();

  const colTable = [
    {
      Header: "Stt",
      accessor: (item, i) => i + 1,
    },
    {
      Header: "Ngày",
      accessor: (item) => moment(item.date).format("DD/MM/YYYY"),
    },
    {
      Header: "Hợp đồng",
      accessor: (item) => item.contractId
    },
    {
      Header: "Nội dung",
      accessor: (item) => item.content
    },

    {
      Header: "Tiền giải ngân($)",
      className: 'text-right',
      accessor: (item) => item.type === 'IN' && <NumericFormat
        displayType={"text"}
        value={item.fundUSD}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tỉ giá giải ngân",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item?.mortgageContract?.exchangeRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền giải ngân(đ)",
      className: 'text-right',
      accessor: (item) => item.type === 'IN' && <NumericFormat
        displayType={"text"}
        value={item.fund}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền trả gốc($)",
      className: 'text-right',
      accessor: (item) => item.type === 'OUT' && <NumericFormat
        displayType={"text"}
        value={item.fundUSD}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tỉ giá gốc",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item?.mortgageContract?.exchangeRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền trả gốc(đ)",
      className: 'text-right',
      accessor: (item) => item.type === 'OUT' && <NumericFormat
        displayType={"text"}
        value={item.fund}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },

    {
      Header: "Tiền trả lãi($)",
      className: 'text-right',
      accessor: (item) => item.type === 'OUT' && <NumericFormat
        displayType={"text"}
        value={item.interestUSD}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tỉ giá lãi",
      className: 'text-right',
      accessor: (item) => item.type === 'OUT' && <NumericFormat
        displayType={"text"}
        value={item.exchangeInterestRate}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Tiền trả lãi(đ)",
      className: 'text-right',
      accessor: (item) => item.type === 'OUT' && <NumericFormat
        displayType={"text"}
        value={item.interest}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />
    },
    {
      Header: "Hành động",
      accessor: (item) => (
        <ul className="nk-tb-actions gx-1">
          <li>
            <UncontrolledDropdown>
              <DropdownToggle
                tag="a"
                className="btn btn-icon dropdown-toggle btn-trigger"
              >
                <Icon name="more-h"></Icon>
              </DropdownToggle>
              <DropdownMenu right>
                <ul className="link-list-opt no-bdr">
                  {/* <li>
                    <DropdownItem
                      tag="a"
                      href="#edit"
                      onClick={(ev) => {
                        ev.preventDefault();
                        toggle("edit");
                        setType(item.type);
                        setEditedId(item.id);
                      }}
                    >
                      <Icon name="edit"></Icon>
                      <span>Cập nhật</span>
                    </DropdownItem>
                  </li> */}

                  <li>
                    <DropdownItem
                      tag="a"
                      href="#dropdown"
                      onClick={(ev) => {
                        ev.preventDefault();
                        setDeleteId(item.id);
                        toggle("isDelete");
                      }}
                    >
                      <Icon name="trash" className="text-danger"></Icon>
                      <span>Xoá</span>
                    </DropdownItem>
                  </li>
                </ul>
              </DropdownMenu>
            </UncontrolledDropdown>
          </li>
        </ul>
      ),
    },
  ];

  useEffect(() => {
    setLoading(true);
    setData([]);

    const newParams = new URLSearchParams({
      ...rangeDate,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    });

    let params = {
      start: moment(rangeDate.start).format("YYYY-MM-DD"),
      end: moment(rangeDate.end).format("YYYY-MM-DD"),

    };


    GET(`/transaction-history/mortgage-contract-transaction-history`, params, true)
      .then(({ data }) => {
        setData([...data?.rows]);
        setSummary({
          ...data.summary,
          count: data.count,
        });

      })
      .finally(() => {
        setLoading(false);
      });
  }, [filter, updatedAt]);


  const onRangeChange = (dates) => {
    const [start, end] = dates;
    setRangeDate({ start: start ? moment(start)?.startOf('days').toDate() : start, end: end ? moment(end)?.endOf('days').toDate() : end });
    if (start && end) {
      setUpdatedAt(moment().valueOf());
    }
  };

  const exportExcel = () => {
    const params = new URLSearchParams({
      start: moment(rangeDate.start).format("YYYY-MM-DD"),
      end: moment(rangeDate.end).format("YYYY-MM-DD"),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/transaction-history/mortgage-contract-transaction-history-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  // function to close the form modal
  const onFormCancel = () => {
    setView({ add: false, edit: false, isDelete: false });
    setEditedId();
    setDeleteId();
    setType('IN');
  };

  const resetData = () => {
    onFormCancel();
  };

  const deleteMortgageContractTransactionHistory = (contractId) => {
    if (!contractId) {
      return;
    }
    DELETE(`/transaction-history/personal-mortgage-contract-transaction-history/remove`, {
      contractId
    }, true)
      .then(() => {
        toast.success("Xóa thành công");
        resetData();
        setUpdatedAt(moment().valueOf());
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  return (
    <React.Fragment>
      <Head title="Quản lý giao dịch"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div
                        className="form-control-wrap"
                        style={{ width: "200px" }}
                      >
                        <DatePicker
                          onKeyDown={(e) => {
                            e.preventDefault();
                          }}
                          dateFormat={'dd/MM/yy'}
                          selected={rangeDate.start}
                          startDate={rangeDate.start}
                          endDate={rangeDate.end}
                          onChange={onRangeChange}
                          maxDate={new Date()}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>

                    <li>
                      <div className="form-control-wrap">
                        <ReactToPrint
                          trigger={() => <Button className={'btn-secondary'}>In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />
                        <Button onClick={exportExcel} className="ml-3 btn-secondary">
                          Xuất excel
                        </Button>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <div className="row justify-between g-2">
                  <div className="col-8 col-sm-6 text-start"></div>
                  <div className="col-5 col-sm-6 text-end">
                    <div className="datatable-filter">
                      <div className="d-flex justify-content-end g-2">
                        <div
                          className="dataTables_length"
                          id="DataTables_Table_1_length"
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="my-3" ref={printRef}>
                  <h5 className="text-center">Chi tiết thu chi vay công ty</h5>
                  <h6 className="text-center">Từ ngày {moment(rangeDate.start).format('DD-MM-YYYY')} đến {moment(rangeDate.end).format('DD-MM-YYYY')}</h6>
                  <Table
                    notShowPagi={true}
                    loading={loading}
                    columns={colTable}
                    data={data}
                    headerRow={<tr className="nk-tb-item odd font-weight-bold">
                      <td colSpan={4}></td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.fundInUSD}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td></td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.fundInVND}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.fundOutUSD}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td></td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.fundOutVND}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.interestOutUSD}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td></td>

                      <td className="nk-tb-col text-right">
                        <NumericFormat
                          displayType={"text"}
                          value={summary?.interestOutVND}
                          thousandsGroupStyle="thousand"
                          thousandSeparator=","
                          decimalScale={2}
                        />
                      </td>
                      <td></td>

                    </tr>}
                  ></Table>
                </div>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default MortgageContractTransactionHistory;
